<ul class="pager">
  <li [class.disabled]="!canPrevious()">
    <a role="button" aria-label="go to first page" (click)="selectPage(1)">
      <i class="{{ pagerPreviousIcon }}"></i>
    </a>
  </li>
  <li [class.disabled]="!canPrevious()">
    <a role="button" aria-label="go to previous page" (click)="prevPage()">
      <i class="{{ pagerLeftArrowIcon }}"></i>
    </a>
  </li>
  <!-- Keep on one line: line breaks render as a space (preserveWhitespaces) -->
  @for (pg of pages; track pg.number) {<li
    role="button"
    [attr.aria-label]="'page ' + pg.number"
    class="pages"
    [class.active]="pg.number === page">
      <a (click)="selectPage(pg.number)">
        {{ pg.text }}
      </a>
  </li>}
  <li [class.disabled]="!canNext()">
    <a role="button" aria-label="go to next page" (click)="nextPage()">
      <i class="{{ pagerRightArrowIcon }}"></i>
    </a>
  </li>
  <li [class.disabled]="!canNext()">
    <a role="button" aria-label="go to last page" (click)="selectPage(totalPages)">
      <i class="{{ pagerNextIcon }}"></i>
    </a>
  </li>
</ul>
